import { Button, Dropdown, Field, Input, Option } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../common/PageHeader';
import { DataTable } from '../../common/DataTable';
import { LoadingState } from '../../common/LoadingState';
import { ErrorState } from '../../common/ErrorState';
import { useOffers } from '../../../hooks/useOffers';
import { OfferStatus } from '../../../models/enums';
import { StatusBadge } from '../../common/StatusBadge';

export const OffersListPage = () => {
  const navigate = useNavigate();
  const { offers, loading, error, search, setSearch, status, setStatus, reload, deleteOffer } = useOffers();
  
  if (loading) return <LoadingState label="Loading offers..." />;
  if (error) return <ErrorState message={error} onRetry={() => void reload()} />;

  return (
    <div>
      <PageHeader title="Offers" subtitle="Draft, validate and send commercial offers" actions={[{ label: 'New offer', onClick: () => navigate('/offers/new'), appearance: 'primary' }]} />
      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        <Field label="Search"><Input value={search} onChange={(_, data) => setSearch(data.value)} /></Field>
        <Field label="Status">
          <Dropdown selectedOptions={[String(status)]} value={status === 'all' ? 'All statuses' : undefined} onOptionSelect={(_, data) => setStatus(data.optionValue === 'all' ? 'all' : Number(data.optionValue) as OfferStatus)}>
            <Option value="all">All statuses</Option>
            <Option value={String(OfferStatus.Brouillon)}>Draft</Option>
            <Option value={String(OfferStatus.EnValidation)}>In review</Option>
            <Option value={String(OfferStatus.Envoyee)}>Sent</Option>
            <Option value={String(OfferStatus.Acceptee)}>Accepted</Option>
            <Option value={String(OfferStatus.Refusee)}>Rejected</Option>
            <Option value={String(OfferStatus.Expiree)}>Expired</Option>
          </Dropdown>
        </Field>
      </div>
      <DataTable
        items={offers}
        columns={[
          { columnId: 'ref', label: 'Reference', renderCell: (item) => item.cr_crm_reference },
          { columnId: 'client', label: 'Client', renderCell: (item) => item.cr_crm_client?.cr_crm_companyname ?? '—' },
          { columnId: 'status', label: 'Status', renderCell: (item) => <StatusBadge value={item.cr_crm_status} /> },
          { columnId: 'total', label: 'Total TND', renderCell: (item) => item.cr_crm_totaltnd?.toFixed(3) ?? '0.000' },
          { columnId: 'action', label: '', renderCell: (item) => <><Button onClick={() => navigate(`/offers/${item.cr_crm_offerid}`)}>Open</Button><Button appearance="subtle" onClick={async () => { if (confirm('Delete this offer?')) { await deleteOffer(item.cr_crm_offerid); reload(); } }}>🗑️</Button></> },
        ]}
        getRowId={(item) => item.cr_crm_offerid}
      />
    </div>
  );
};
